import React, {useEffect, useState} from "react";
import "./CardAndOffer.scss";
import type {TabsProps} from "antd";
import {Tabs} from "components/common";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setButtonsHeader, setSiderKey} from "redux/reducer/common";
import {tabKeys} from "types/enums";
import CardTypes from "./components/CardTypes/CardTypes";
import Discounts from "./components/Discounts/Discounts";
import DiscountsAdd from "./components/DiscountsAdd/DiscountsAdd";
import Marketing from "pages/AccoutingFinancial/CombineReport/Marketing";
import TheKham from "pages/AccoutingFinancial/CombineReport/TheKham";

const CardAndOffer = () => {
  document.title = "Thẻ khám và chương trình ưu đãi";
  const [isDisabled, setIsDisabled] = useState(true);
  const [isDisabledCT, setIsDisabledCT] = useState(true);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setButtonsHeader([]));
    dispatch(setSiderKey("theKham"));
  }, []);
  const items: TabsProps["items"] = [
    {
      key: tabKeys.CARD_AND_OFFER.CARD_TYPES,
      label: `Loại thẻ khám`,
      children: <CardTypes />,
    },
    {
      key: tabKeys.CARD_AND_OFFER.DISCOUNTS,
      label: `Chương trình ưu đãi`,
      children: (
        <Discounts
          setIsTabDisabled={setIsDisabled}
          setIsTabDisabledCT={setIsDisabledCT}
        />
      ),
    },
    {
      key: tabKeys.CARD_AND_OFFER.DISCOUNTSADD,
      label: `Chi tiết chương trình ưu đãi`,
      children: <DiscountsAdd />,
      disabled: isDisabledCT,
    },
    {
      key: tabKeys.COMBINE_REPORT.MARKKETING_REPORT,
      label: "Báo cáo marketing",
      children: <Marketing />,
    },
    {
      key: tabKeys.COMBINE_REPORT.THEKHAM_REPORT,
      label: "Báo cáo thẻ khám",
      children: <TheKham />,
    },
  ];

  const activeTab = useAppSelector(state => state.common.activeTab);

  useEffect(() => {}, [activeTab]);
  return (
    <div className="service-and-offer page">
      <div className="main">
        <Tabs activeKey={activeTab} items={items} />
      </div>
    </div>
  );
};

export default CardAndOffer;
